import axios from 'axios';
import https from 'https';

const httpsAgent = new https.Agent({
	rejectUnauthorized: false,
});
const instance = axios.create({
	baseURL: `${process.env.VUE_APP_APIURL}/api`,
	httpsAgent,
});

export default {
	namespaced: true,
	state: {
		online_resv_np: '0',
		captcha: {},
		message: '',
	},
	actions: {
		async getSettings(context, status) {
			const clinicCode = status;
			const api = `/settings`;
			context.commit('LOADING', true, { root: true });
			try {
				const res = await instance({
					method: 'post',
					url: api,
					headers: { clinic_code: clinicCode },
				});
				let online_resv_np,
					online_resv_op,
					online_headquarter_np,
					online_cancel_day,
					dental_is_enable,
					online_prefix,
					bookings,
					rooms,
					online_resv_type,
					resv_hours,
					mgm_enable = null;
				let info = {};
				if (res.data.msg == 'settings api not found') {
					online_resv_np = 0;
				} else {
					info = res.data.info;
					const settings = res.data.data.settings;
					online_resv_np = settings.online_resv_np;
					online_resv_op = settings.online_resv_op;
					online_headquarter_np = settings.online_headquarter_np;
					online_cancel_day = settings.online_cancel_day;
					dental_is_enable = settings.dental_is_enable;
					online_prefix =
						settings.online_prefix !== undefined ? settings.online_prefix : '';
					online_resv_type = settings.online_resv_type || 'cusid';
					bookings = res.data.data.bookings;
					rooms = res.data.data.rooms;
					resv_hours = res.data.data.resv_hours;
					mgm_enable = settings.mgm_enable || '0';
				}
				context.commit('SET_CLINIC', { info, clinicCode });
				context.commit('ONLINE_RESV_NP', { online_resv_np, clinicCode });
				context.commit('ONLINE_RESV_OP', { online_resv_op, clinicCode });
				context.commit('ONLINE_HEADQUARTER_NP', {
					online_headquarter_np,
					clinicCode,
				});
				context.commit('ONLINE_CANCEL_DAY', { online_cancel_day, clinicCode });
				context.commit('DENTAL_IS_ENABLE', { dental_is_enable, clinicCode });
				context.commit('ONLINE_PREFIX', { online_prefix, clinicCode });
				context.commit('ONLINE_RESV_TYPE', { online_resv_type, clinicCode });
				context.commit('BOOKINGS', { bookings, clinicCode });
				context.commit('ROOMS', { rooms, clinicCode });
				context.commit('RESV_HOURS', { resv_hours, clinicCode });
				context.commit('MGM_IS_ENABLE', {
					mgm_is_enable: mgm_enable,
					clinicCode,
				});
				context.commit('LOADING', false, { root: true });
				return res;
			} catch (err) {
				context.commit('LOADING', false, { root: true });
				throw err;
			}
		},
		async getCaptcha(context) {
			let clinicCode = '';
			if (localStorage.getItem('clinicCode')) {
				clinicCode = localStorage.getItem('clinicCode');
			}
			const api = `/captchas`;
			try {
				const res = await instance({
					method: 'post',
					url: api,
					headers: { clinic_code: clinicCode },
				});
				context.commit('CAPTCHA', res.data.data.captcha);
				return res;
			} catch (err) {
				console.log(err);
				throw err;
			}
		},
		async login(context, status) {
			const { data, clinicCode, justNp, justOp } = status;
			const api = `/customers/check`;
			context.commit('LOADING', true, { root: true });
			try {
				const res = await instance({
					method: 'post',
					url: api,
					data: data,
					headers: { clinic_code: clinicCode },
				});
				if (res.data.status == 'error') {
					throw res.data.msg;
				} else {
					let { token, customer, rooms, newpatient, online_limits } =
						res.data.data;
					let nnp = {};
					if (justNp && customer) {
						throw new Error('僅開放新顧客約診');
					}
					if (justOp && newpatient) {
						throw new Error('僅開放舊顧客約診');
					}
					if (!customer && !newpatient) {
						nnp = { birthday: '', name: '', mobile: data.get('mobile') };
					}
					customer = customer ? customer : {};
					newpatient = newpatient ? newpatient : {};

					if (online_limits && online_limits.length > 0) {
						const max = online_limits.reduce((prev, current) => {
							return prev.end > current.end ? prev : current;
						});
						if (max.end < new Date().toISOString().split('T')[0]) {
							throw new Error('目前無進行中的療程，無法約診，請來電洽詢');
						}
					}

					localStorage.setItem(`token_${clinicCode}`, token);
					context.commit('CUSTOMER', { customer, clinicCode });
					context.commit('NEWPATIENT', { newpatient, clinicCode });
					if (online_limits && online_limits.length > 0) {
						context.commit('ONLINE_LIMITS', { online_limits, clinicCode });
					}
					context.commit('NNP', { nnp, clinicCode });
					context.commit('ROOMS', { rooms, clinicCode });
					context.commit('LOADING', false, { root: true });
					return res;
				}
			} catch (err) {
				if (err.response && err.response.data.status == 'failed') {
					const customerError = new Error(err.response.data.message);
					throw customerError;
				}
				context.commit('LOADING', false, { root: true });
				throw err;
			} finally {
				context.commit('LOADING', false, { root: true });
			}
		},
		setNnp(context, status) {
			context.commit('NNP', status);
		},
	},
	mutations: {
		SET_CLINIC(state, status) {
			const { info, clinicCode } = status;
			localStorage.setItem(`clinic_${clinicCode}`, JSON.stringify(info));
		},
		ONLINE_RESV_NP(state, status) {
			const { online_resv_np, clinicCode } = status;
			localStorage.setItem(`online_resv_np_${clinicCode}`, online_resv_np);
		},
		ONLINE_RESV_OP(state, status) {
			const { online_resv_op, clinicCode } = status;
			localStorage.setItem(`online_resv_op_${clinicCode}`, online_resv_op);
		},
		ONLINE_HEADQUARTER_NP(state, status) {
			const { online_headquarter_np, clinicCode } = status;
			localStorage.setItem(
				`online_headquarter_np_${clinicCode}`,
				online_headquarter_np,
			);
		},
		ONLINE_CANCEL_DAY(state, status) {
			const { online_cancel_day, clinicCode } = status;
			localStorage.setItem(
				`online_cancel_day_${clinicCode}`,
				online_cancel_day,
			);
		},
		ONLINE_PREFIX(state, status) {
			const { online_prefix, clinicCode } = status;
			localStorage.setItem(
				`online_prefix_${clinicCode}`,
				JSON.stringify(online_prefix),
			);
		},
		ONLINE_RESV_TYPE(state, status) {
			const { online_resv_type, clinicCode } = status;
			localStorage.setItem(`online_resv_type_${clinicCode}`, online_resv_type);
		},
		DENTAL_IS_ENABLE(state, status) {
			const { dental_is_enable, clinicCode } = status;
			localStorage.setItem(
				`dental_is_enable_${clinicCode}`,
				JSON.stringify(dental_is_enable),
			);
		},
		BOOKINGS(state, status) {
			const { bookings, clinicCode } = status;
			localStorage.setItem(`bookings_${clinicCode}`, JSON.stringify(bookings));
		},
		RESV_HOURS(state, status) {
			const { resv_hours, clinicCode } = status;
			localStorage.setItem(
				`resv_hours_${clinicCode}`,
				JSON.stringify(resv_hours),
			);
		},
		CAPTCHA(state, status) {
			state.captcha = status;
		},
		MESSAGE(state, status) {
			state.message = status;
		},
		CUSTOMER(state, status) {
			const { customer, clinicCode } = status;
			localStorage.setItem(`customer_${clinicCode}`, JSON.stringify(customer));
		},
		NEWPATIENT(state, status) {
			const { newpatient, clinicCode } = status;
			localStorage.setItem(
				`newpatient_${clinicCode}`,
				JSON.stringify(newpatient),
			);
		},
		ONLINE_LIMITS(state, status) {
			const { online_limits, clinicCode } = status;
			localStorage.setItem(
				`online_limits_${clinicCode}`,
				JSON.stringify(online_limits),
			);
		},
		NNP(state, status) {
			const { nnp, clinicCode } = status;
			const { birthday, mobile, name } = nnp;
			localStorage.setItem(
				`nnp_${clinicCode}`,
				JSON.stringify({ birthday, mobile, name }),
			);
		},
		ROOMS(state, status) {
			const { rooms, clinicCode } = status;
			localStorage.setItem(`rooms_${clinicCode}`, JSON.stringify(rooms));
		},
		MGM_IS_ENABLE(state, status) {
			const { mgm_is_enable, clinicCode } = status;
			localStorage.setItem(`mgm_is_enable_${clinicCode}`, mgm_is_enable);
		},
	},
	getters: {
		clinicByC: () => (clinicCode) => {
			const clinic = localStorage.getItem(`clinic_${clinicCode}`);
			if (clinic !== null) {
				return JSON.parse(clinic);
			} else {
				return {};
			}
		},
		onlineResvNp: () => (clinicCode) => {
			const online_resv_np = localStorage.getItem(
				`online_resv_np_${clinicCode}`,
			);
			if (online_resv_np) {
				return parseInt(online_resv_np);
			} else {
				return null;
			}
		},
		onlineResvOp: () => (clinicCode) => {
			const online_resv_op = localStorage.getItem(
				`online_resv_op_${clinicCode}`,
			);
			if (online_resv_op) {
				return parseInt(online_resv_op);
			} else {
				return null;
			}
		},
		onlineHeadquarterNp: () => (clinicCode) => {
			const online_headquarter_np = localStorage.getItem(
				`online_headquarter_np_${clinicCode}`,
			);
			if (online_headquarter_np) {
				return parseInt(online_headquarter_np);
			} else {
				return null;
			}
		},
		onlineLimits: () => (clinicCode) => {
			const online_limits = localStorage.getItem(`online_limits_${clinicCode}`);
			if (online_limits !== 'undefined') {
				return JSON.parse(online_limits);
			} else {
				return [];
			}
		},
		onlineCancelDay: () => (clinicCode) => {
			const online_cancel_day = localStorage.getItem(
				`online_cancel_day_${clinicCode}`,
			);
			if (online_cancel_day) {
				return parseInt(online_cancel_day);
			} else {
				return null;
			}
		},
		dentalIsEnableByC: () => (clinicCode) => {
			const dental_is_enable = localStorage.getItem(
				`dental_is_enable_${clinicCode}`,
			);
			if (dental_is_enable) {
				return JSON.parse(dental_is_enable);
			} else {
				return {};
			}
		},
		bookingsByC: () => (clinicCode) => {
			const bookings = localStorage.getItem(`bookings_${clinicCode}`);
			if (bookings) {
				return JSON.parse(bookings);
			} else {
				return {};
			}
		},
		resvHoursByC: () => (clinicCode) => {
			const resv_hours = localStorage.getItem(`resv_hours_${clinicCode}`);
			if (resv_hours) {
				return JSON.parse(resv_hours);
			} else {
				return {};
			}
		},
		captcha(state) {
			return state.captcha;
		},
		customerByC: () => (clinicCode) => {
			const customer = localStorage.getItem(`customer_${clinicCode}`);
			if (customer) {
				return JSON.parse(customer);
			} else {
				return {};
			}
		},
		newpatientByC: () => (clinicCode) => {
			const newpatient = localStorage.getItem(`newpatient_${clinicCode}`);
			if (newpatient) {
				return JSON.parse(newpatient);
			} else {
				return {};
			}
		},
		nnpByC: () => (clinicCode) => {
			const nnp = localStorage.getItem(`nnp_${clinicCode}`);
			if (nnp) {
				return JSON.parse(nnp);
			} else {
				return {};
			}
		},
		roomsByC: () => (clinicCode) => {
			const rooms = localStorage.getItem(`rooms_${clinicCode}`);
			return JSON.parse(rooms);
		},
		message(state) {
			return state.message;
		},
		mgmIsEnableByC: () => (clinicCode) => {
			const mgm_is_enable = localStorage.getItem(`mgm_is_enable_${clinicCode}`);
			console.log('mgm_is_enable', mgm_is_enable);
			return mgm_is_enable;
		},
	},
};
